var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6714_8371)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75012 2C1.28599 2 0.840873 2.18437 0.512685 2.51256C0.184496 2.84075 0.00012151 3.28587 0.00012151 3.75L0.00012151 4.486C-4.05033e-05 4.495 -4.05033e-05 4.504 0.00012151 4.513L0.00012151 12.25C0.00012151 13.216 0.784121 14 1.75012 14H14.2501C14.7142 14 15.1594 13.8156 15.4876 13.4874C15.8157 13.1592 16.0001 12.7141 16.0001 12.25V3.75C16.0001 3.28587 15.8157 2.84075 15.4876 2.51256C15.1594 2.18437 14.7142 2 14.2501 2H1.75012ZM14.5001 4.07V3.75C14.5001 3.6837 14.4738 3.62011 14.4269 3.57322C14.38 3.52634 14.3164 3.5 14.2501 3.5H1.75012C1.68382 3.5 1.62023 3.52634 1.57334 3.57322C1.52646 3.62011 1.50012 3.6837 1.50012 3.75V4.07L8.00012 7.88L14.5001 4.07ZM1.50012 5.81V12.251C1.50012 12.389 1.61212 12.501 1.75012 12.501H14.2501C14.3164 12.501 14.38 12.4747 14.4269 12.4278C14.4738 12.3809 14.5001 12.3173 14.5001 12.251V5.809L8.38012 9.397C8.26493 9.4647 8.13374 9.50039 8.00012 9.50039C7.86651 9.50039 7.73532 9.4647 7.62012 9.397L1.50012 5.809V5.81Z",
    fill: "#406578"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6714_8371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail16);
export default __webpack_public_path__ + "static/media/mail-16.6b905ea604b549fbae5cc5edaa39644a.svg";
export { ForwardRef as ReactComponent };